<template>
  <div class="details">
    <form-title>账号信息</form-title>
    <info-panel :padding="24">
      <el-row>
        <el-col :span="col">
          <info-item label="手机号码">
            {{ result.mobilePhone }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="真实姓名">
            {{ result.realName }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="微信昵称">
            {{ result.wechatNickName }}
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="col">
          <info-item label="身份信息">
            {{ identityInformationText }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="状态">
            <status :props="result.identityValid">
              {{ result.identityValid === types.INDENTITY_VALID_ENABLE ? '启用' : '禁用' }}
            </status>
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="微信头像">
            <el-image
              :src="result.wechatAvatarUrl"
              :preview-src-list="[result.wechatAvatarUrl]"
            />
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="col">
          <info-item label="备注">
            {{ result.identityRemark }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="创建人">
            {{ result.createByName }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="创建时间">
            {{ $time(Number(result.identityCreateTime)).format('YYYY/MM/DD HH:mm:ss') }}
          </info-item>
        </el-col>
      </el-row>
      <el-row v-if="result.identityType === types.TEACHER">
        <el-row>
          <el-col :span="col">
            <info-item label="老师标签">
              {{ result.teacherIntro }}
            </info-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="col">
            <info-item label="老师介绍">
              {{ result.teacherDesc }}
            </info-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="col">
            <info-item label="老师照片">
              <el-image
                :src="result.teacherPic"
                :preview-src-list="[result.teacherPic]"
              />
            </info-item>
          </el-col>
        </el-row>
        <el-col :span="col">
          <info-item label="是否精选展示">
            <status :props="result.teacherIsShowMp">
              {{ result.teacherIsShowMp === types.IS_SHOW_MAP_ENABLE ? '是' : '否' }}
            </status>
          </info-item>
        </el-col>
      </el-row>
    </info-panel>
    <form-title>菜单信息</form-title>
    <info-panel>
      <el-tree
        :data="result.permissionList"
        :props="treeProps"
      />
    </info-panel>
    <form-title>修改记录</form-title>
    <data-table
      :data="tabelData"
      scroll
      :table-column="tableColumn"
    />
  </div>
</template>
<script>
import infoPanel from '@/components/common/infoPanel.vue';
import infoItem from '@/components/common/infoItem.vue';
import formTitle from '@/components/common/formTitle.vue';
import dataTable from '@/components/common/dataTable.vue';
import avatarImg from '@/assets/images/header/avatar.png';
import axClient from '@/services';
import types, { identityInformation } from '@/config';
import status from '@/components/common/status.vue';

export default {
  name: 'AccountDetails',
  components: {
    formTitle,
    infoPanel,
    infoItem,
    status,
    dataTable,
  },
  data() {
    return {
      types,
      avatarImg,
      col: 5,
      result: {},
      tabelData: [],
      pageIndex: 1,
      pageSize: 9999,
      treeProps: {
        children: 'sonList',
        label: 'permissionName',
      },
      tableColumn: [
        {
          key: 'createByRealName',
          label: '操作者姓名',
          width: '120px',
          dataType: 'text',
        },
        {
          key: 'createByLoginName',
          label: '操作者账号',
          width: '160px',
          dataType: 'text',
        },
        {
          key: 'content',
          label: '修改信息',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'createTime',
          label: '修改时间',
          width: 'auto',
          dataType: 'time',
        },
      ],
    };
  },
  computed: {
    identityInformationText() {
      if (!this.result.identityType) return null;
      return identityInformation.filter((v) => v.value === this.result.identityType).map((v) => v.label).join();
    },
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    // 详情
    async getInfo() {
      this.result = await axClient.account.getInfo(this.$route.params.id);
      const result = await axClient.common.getLog({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        targetId: this.result.userId,
        targetType: 10,
      });
      // const { pageNum, pageSize, total } = result;
      this.tabelData = result.list;
    },
  },
};
</script>
<style lang="scss" scoped>
.details {
  .title {
    margin-top: 12px;
  }
  .el-table {
    margin-top: 24px;
  }
}
</style>